import { Box } from '@mui/material';
import { FormTitleBox, LoadingSkeleton, TableBodySkeleton } from '../common/components';
import AssignmentIcon from '@mui/icons-material/Assignment';

// Componentes separados
import PlansDataTable from './components/PlansDataTable';
import PlanEditDialog from './components/PlanEditDialog';

// Hook personalizado
import { usePlansTable } from './hooks/usePlansTable';

/**
 * Componente principal de la tabla de planes
 * Refactorizado para seguir los patrones del proyecto con TanStack Query
 */
const PlansTable = () => {
  // Hook personalizado que maneja toda la lógica
  const {
    // Estados de datos
    filteredPlans,
    isLoading,
    page,
    searchTerm,

    // Estados de diálogo
    dialogOpen,
    editMode,
    selectedPlan,

    // Datos de soporte
    branches,
    feeTypes,

    // Funciones de manejo
    handleSearch,
    handlePageChange,
    handleOpenDialog,
    handleCloseDialog,
    handleEdit,
    handleDelete,
    handleSave,
    handleInputChange,
    handleSelectChange,

    // Paginación
    getCurrentPageItems,
    totalPages,
    rowsPerPage,
    handleRowsPerPageChange,
  } = usePlansTable();

  return (
    <>
      <Box>
        <FormTitleBox
          title="Planes"
          showButton={true}
          buttonText="Agregar Plan"
          buttonIcon={AssignmentIcon}
          onButtonClick={handleOpenDialog}
          showSearch={true}
          searchLabel="Buscar plan"
          searchValue={searchTerm}
          onSearchChange={handleSearch}
          searchSize="medium"
        />

        <PlansDataTable
          plans={getCurrentPageItems()}
          totalPlans={filteredPlans.length}
          page={page}
          totalPages={totalPages}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          onEdit={handleEdit}
          onDelete={handleDelete}
          isLoading={isLoading}
          LoadingComponent={TableBodySkeleton}
        />
      </Box>

      <PlanEditDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        editMode={editMode}
        selectedPlan={selectedPlan}
        branches={branches}
        feeTypes={feeTypes}
        onInputChange={handleInputChange}
        onSelectChange={handleSelectChange}
        onSave={handleSave}
      />
    </>
  );
};

export default PlansTable;
